import { render, staticRenderFns } from "./PageBalanceHistory.vue?vue&type=template&id=5487ad36&scoped=true"
import script from "./PageBalanceHistory.vue?vue&type=script&lang=js"
export * from "./PageBalanceHistory.vue?vue&type=script&lang=js"
import style0 from "./PageBalanceHistory.vue?vue&type=style&index=0&id=5487ad36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5487ad36",
  null
  
)

export default component.exports